export type ScimTokenJSON = {
	active: boolean;
	created_at: string | null;
	scim_url: string;
}

export default class ScimToken {
	active: boolean;
	createdAt: string | null;
	scimUrl: string;

	constructor( active: boolean, createdAt: string | null, scimUrl: string ) {
		this.active = active;
		this.createdAt = createdAt;
		this.scimUrl = scimUrl;
	}

	static fromJSON( json: ScimTokenJSON ): ScimToken {
		return new ScimToken( json.active, json.created_at, json.scim_url );
	}
}
